import React, { useState, useEffect } from 'react';
import { SITE } from '../data/siteData';
import { fetchAllPosts, CATEGORIES, LINKEDIN_URL } from '../data/blogData';
import './Blogs.css';
import Icon from '../components/Icon';

export default function Blogs() {
  const [active, setActive] = useState('all');
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    fetchAllPosts().then(p => {
      if (alive) { setPosts(p); setLoading(false); }
    });
    return () => { alive = false; };
  }, []);

  const filtered = active === 'all' ? posts : posts.filter(b => b.category === active);

  return (
    <div className="blogs-page">
      {/* Hero */}
      <section className="blogs-hero">
        <div className="bh-overlay" />
        <div className="bh-content container">
          <div className="bh-label">Insights & Education</div>
          <h1 className="bh-title">Financial Blog</h1>
          <p className="bh-sub">Expert articles, market insights, and investment tips from G.M. Narendra — helping you make smarter financial decisions.</p>
        </div>
      </section>

      {/* Blog grid */}
      <section className="blogs-grid-sec container">
        {loading ? (
          <p style={{ textAlign: 'center', color: '#888', padding: '40px 0' }}>Loading articles…</p>
        ) : (
          <>
            <div className="blogs-grid">
              {filtered.map((b, i) => (
                <article key={b.id} className={`blog-full-card${i === 0 && active === 'all' ? ' featured' : ''}`}>
                  <div className="bfc-img-wrap">
                    <img src={b.img} alt={b.title} className="bfc-img" />
                  </div>
                  <div className="bfc-body">
                    <div className="bfc-meta">
                      <span className="bfc-author">✍️ {b.author}</span>
                      <span className="bfc-date">{b.date}</span>
                    </div>
                    <h2 className="bfc-title">{b.title}</h2>
                    <p className="bfc-excerpt">{b.excerpt}</p>
                    {b.linkedinUrl ? (
                      <a 
                        href={b.linkedinUrl} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="bfc-cta"
                      >
                        Read Full Article on LinkedIn →
                      </a>
                    ) : (
                      <a 
                        href={LINKEDIN_URL} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="bfc-cta"
                      >
                        Read Full Article on LinkedIn →
                      </a>
                    )}
                  </div>
                </article>
              ))}
            </div>
            
            {/* View More on LinkedIn - Centered at bottom */}
            <div style={{ textAlign: 'center', marginTop: '50px' }}>
              <a 
                href={'https://www.linkedin.com/in/narendragm03?utm_source=share_via&utm_content=profile&utm_medium=member_ios'} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bh-linkedin"
                style={{ 
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '12px 32px',
                  backgroundColor: '#0a66c2',
                  color: 'white',
                  borderRadius: '24px',
                  textDecoration: 'none',
                  fontWeight: '600',
                  fontSize: '1rem',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#004182';
                  e.target.style.transform = 'translateY(-2px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#0a66c2';
                  e.target.style.transform = 'translateY(0)';
                }}
              >
                <span className="bh-li-icon" style={{ 
                  display: 'inline-block',
                  backgroundColor: 'white',
                  color: '#0a66c2',
                  width: '24px',
                  height: '24px',
                  borderRadius: '4px',
                  lineHeight: '24px',
                  textAlign: 'center',
                  fontWeight: '700',
                  fontSize: '14px'
                }}>in</span> 
                View More on LinkedIn →
              </a>
            </div>
          </>
        )}
      </section>

      {/* CTA Strip */}
      <section className="blogs-cta">
        <div className="container" style={{ textAlign: 'center' }}>
          <div className="section-label" style={{ justifyContent: 'center' }}>Stay Updated</div>
          <h2 className="section-title">Have a Financial Question?</h2>
          <p className="section-sub" style={{ maxWidth: 480, margin: '12px auto 32px' }}>
            Our experts are ready to answer your questions and guide you toward the right financial decisions.
          </p>
          <div style={{ display: 'flex', gap: 14, justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href={`tel:${SITE.contact.phone}`} className="btn-primary">📞 Talk to an Advisor</a>
            <a href="/contact" className="btn-ghost">Send a Question →</a>
          </div>
        </div>
      </section>
    </div>
  );
}